const EmailIcon = () => {
	return (
		<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="28" cy="28" r="28" fill="#F6F6F6" />
			<path
				d="M38.3158 17.6855H17.6842C16.0565 17.6855 14.7369 19.0051 14.7369 20.6329V35.3698C14.7369 36.9975 16.0565 38.3171 17.6842 38.3171H38.3158C39.9436 38.3171 41.2632 36.9975 41.2632 35.3698V20.6329C41.2632 19.0051 39.9436 17.6855 38.3158 17.6855Z"
				stroke="var(--general-count-action-color)"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M14.7369 20.6328L28 29.4749L41.2632 20.6328"
				stroke="var(--general-count-action-color)"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export default EmailIcon;
